import { get, set } from 'lodash';
import * as C from '../constants';

const defaultState: FAQState = {
  views: {},
  isError: false,
};

export const getFAQByView = (state: FAQState) => (view: string) =>
  get(state.views, view, []);

export const getFAQErrorState = (state: FAQState) => state.isError;

function handleReceivedFAQ(
  state: FAQState,
  action: FAQReceivedAction
): FAQState {
  return set(
    { ...state, isError: false },
    `views.${action.payload.view}`,
    action.payload.data
  ) as FAQState;
}

function handleFetchFAQError(state: FAQState, action: Action): FAQState {
  return { ...state, isError: true };
}

export default function faq(
  state: FAQState = defaultState,
  action: Action
): FAQState {
  switch (action.type) {
    case C.ACTION_TYPES.FAQ_RECEIVED:
      return handleReceivedFAQ(state, action as FAQReceivedAction);
    case C.ACTION_TYPES.FAQ_FETCH_ERROR:
      return handleFetchFAQError(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/faq.ts